import React, { useEffect, useRef, useState, CSSProperties } from 'react';
import Wavesurfer from 'wavesurfer.js';
import PlayIcon from '../../../assets/playIcon.svg';
import PauseIcon from '../../../assets/pauseIcon.svg';
import { Col, Row } from 'react-bootstrap';
import { Lesson } from '../../../entities/Lesson';
import AttachmentSection from './AttachmentSection';

interface AudioSectionProps {
  currentlesson: Lesson;
  onAudioEnded?: () => void;
}
const AudioSection: React.FC<AudioSectionProps> = ({
  currentlesson,
  onAudioEnded
}) => {
  const waveform = useRef<Wavesurfer>();
  const [playing, setPlaying] = useState<boolean>(false);
  const [duration, setDuration] = useState<string>('');
  const [currentTime, setCurrentTime] = useState<string>('');
  useEffect(() => {
    if (!waveform.current) {
      waveform.current = Wavesurfer.create({
        container: '#waveform',
        waveColor: '#999999',
        barGap: 8,
        barWidth: 9,
        barRadius: 7,
        cursorWidth: 1,
        cursorColor: 'white',
        height: 150,
        progressColor: '#FF9E00',
        backend: 'MediaElement'
      });
      waveform.current.load(currentlesson.audioUrl);
      setPlaying(true);
    }

    return () => waveform.current!.destroy();
  }, []);

  useEffect(() => {
    if (waveform) {
      waveform.current!.on('finish', () => {
        setPlaying(false);
        if (onAudioEnded) onAudioEnded();
      });
      waveform.current!.on('ready', () => {
        setCurrentTime('0:00');
        setDuration(timeCalculator(waveform.current!.getDuration()));
        setPlaying(true);
        waveform.current?.playPause();
      });
      waveform.current!.on('audioprocess', () => {
        setCurrentTime(timeCalculator(waveform.current!.getCurrentTime()));
      });
    }
  }, [waveform]);

  const timeCalculator = (time: number) => {
    const second = Math.floor(time % 60);
    let strSeconds = `${second}`;
    const minute = Math.floor((time / 60) % 60);
    if (second < 10) {
      strSeconds = `0${second}`;
    }
    return `${minute}:${strSeconds}`;
  };

  const playAudio = () => {
    if (waveform && waveform.current!.isPlaying()) {
      waveform.current!.pause();
      setPlaying(false);
    } else {
      waveform.current!.play();
      setPlaying(true);
    }
  };

  return (
    <>
      <div style={mainComponent}>
        <Row style={firstRow}>
          <Col md={{ span: 8, offset: 2 }}>
            <div id="waveform"> </div>
            <Row>
              <Col>{currentTime}</Col>
              <Col>
                <Row className="justify-content-end">{duration}</Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row style={playPauseRow}>
          <button style={buttonPlay}>
            {playing ? (
              <img
                width="80px"
                height="80px"
                src={PauseIcon}
                onClick={playAudio}
                alt=""
              />
            ) : (
              <img
                width="80px"
                height="80px"
                src={PlayIcon}
                onClick={playAudio}
                alt=""
              />
            )}
          </button>
        </Row>
      </div>
      <AttachmentSection currentLesson={currentlesson} />
    </>
  );
};

const mainComponent: CSSProperties = {
  background: '#2B2A2A',
  borderColor: 'fa9e04',
  height: '650px',
  borderRadius: '14px'
};

const firstRow: CSSProperties = {
  paddingTop: '90px'
};
const playPauseRow: CSSProperties = {
  paddingTop: '30px'
};
const buttonPlay: CSSProperties = {
  background: 'none',
  border: 'none',
  paddingTop: '30px'
};
export default AudioSection;
